// This middleware stops the loader after the response is received.

import store from '@/store';

export default {
  async applyAfterware(data, next) {
    await store.dispatch('decrementLoader');
    next();
  },
};



// WEBPACK FOOTER //
// ./api/afterwares/loader.js